import React from 'react';
import { Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Parameters from './Parameters/Parameters';
import { authentication } from '../Authentication';
import { ContentRoute } from 'src/_metronic/layout';
import Organizations from './Organizations/Organizations';
import AdministrativeUnit from './AdministrativeUnit/AdministrativeUnit';

const CatalogManagementPage = () => {
	const user = useSelector((state) => state.auth.user);

	return (
		<Switch>
			{/* TODOS LOS SUBMODULOS DE CATALOGOS */}
			{authentication.hasRole(
				['ADMINISTRADOR GENERAL', 'RESPONSABLE DE NEGOCIO', 'SISTEMA'],
				user
			) ? (
				<div>
					<ContentRoute
						path="/administracion-de-catalogos/unidades-admistrativas"
						component={AdministrativeUnit}
					/>
					<ContentRoute
						path="/administracion-de-catalogos/organizaciones"
						component={Organizations}
					/>
					<ContentRoute
						path="/administracion-de-catalogos/parametros-del-sistema"
						component={Parameters}
					/>
					{/* FIN TODOS LOS SUBMODULOS DE CATALOGOS */}
				</div>
			) : (
				''
			)}
			{/* SOLO CATALOGOS DE UNIDADES Y ORGANIZACIONES */}
			{authentication.hasRole(
				['RESPONSABLE DE ORGANO COLEGIADO', 'RESPONSABLE DE SEGUIMIENTO'],
				user
			) ? (
				<div>
					<ContentRoute
						path="/administracion-de-catalogos/unidades-admistrativas"
						component={AdministrativeUnit}
					/>
					<ContentRoute
						path="/administracion-de-catalogos/organizaciones"
						component={Organizations}
					/>

					{/* FIN SOLO CATALOGOS DE UNIDADES Y ORGANIZACIONES */}
				</div>
			) : (
				''
			)}
		</Switch>
	);
};

export default CatalogManagementPage;
